module.exports = __webpack_public_path__ + "img/Planner-icon.8007bfa0.svg";